import React from "react";

const IndianRupeeIcon = ({
    fill="black"
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_11363_65797)">
        <path
          d="M5.33346 5.33336H10.6668M5.33346 8.00002H10.6668M8.6668 11.3334L5.33346 10.6667H6.00013C6.70737 10.6667 7.38565 10.3857 7.88575 9.88564C8.38584 9.38555 8.6668 8.70727 8.6668 8.00002C8.6668 7.29278 8.38584 6.6145 7.88575 6.11441C7.38565 5.61431 6.70737 5.33336 6.00013 5.33336M2.5668 5.74669C2.46949 5.30838 2.48443 4.85259 2.61023 4.42158C2.73604 3.99058 2.96863 3.59832 3.28644 3.28117C3.60425 2.96402 3.997 2.73225 4.42827 2.60735C4.85953 2.48245 5.31535 2.46847 5.75346 2.56669C5.9946 2.18956 6.3268 1.8792 6.71943 1.66421C7.11206 1.44923 7.55249 1.33655 8.00013 1.33655C8.44776 1.33655 8.8882 1.44923 9.28083 1.66421C9.67346 1.8792 10.0057 2.18956 10.2468 2.56669C10.6856 2.46804 11.1422 2.48196 11.5741 2.60717C12.0061 2.73237 12.3994 2.96478 12.7174 3.28279C13.0354 3.6008 13.2678 3.99407 13.393 4.42603C13.5182 4.85798 13.5321 5.31458 13.4335 5.75336C13.8106 5.9945 14.121 6.32669 14.3359 6.71932C14.5509 7.11196 14.6636 7.55239 14.6636 8.00002C14.6636 8.44766 14.5509 8.88809 14.3359 9.28072C14.121 9.67336 13.8106 10.0056 13.4335 10.2467C13.5317 10.6848 13.5177 11.1406 13.3928 11.5719C13.2679 12.0032 13.0361 12.3959 12.719 12.7137C12.4018 13.0315 12.0096 13.2641 11.5786 13.3899C11.1476 13.5157 10.6918 13.5307 10.2535 13.4334C10.0126 13.8119 9.68018 14.1236 9.28688 14.3396C8.89358 14.5555 8.45215 14.6687 8.00346 14.6687C7.55478 14.6687 7.11335 14.5555 6.72004 14.3396C6.32674 14.1236 5.99429 13.8119 5.75346 13.4334C5.31535 13.5316 4.85953 13.5176 4.42827 13.3927C3.997 13.2678 3.60425 13.036 3.28644 12.7189C2.96863 12.4017 2.73604 12.0095 2.61023 11.5785C2.48443 11.1475 2.46949 10.6917 2.5668 10.2534C2.18677 10.0129 1.87374 9.68014 1.65683 9.28617C1.43992 8.8922 1.32617 8.44976 1.32617 8.00002C1.32617 7.55029 1.43992 7.10785 1.65683 6.71388C1.87374 6.31991 2.18677 5.9872 2.5668 5.74669Z"
          stroke={fill}
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11363_65797">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IndianRupeeIcon;
